(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-cart-upsell"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root=document.querySelector('[data-aura-offer]');
  if(!root||root.dataset.initialized)return;
  root.dataset.initialized='true';
  const form=root.querySelector('form');
  const product=JSON.parse(root.querySelector('[data-aura-product]').textContent);
  const select=form.querySelector('[name="id"]');
  const money=value=>new Intl.NumberFormat('sr-RS',{style:'currency',currency:window.Shopify.currency.active,minimumFractionDigits:2,maximumFractionDigits:2}).format(value/100);
  const showPrice=()=>{
    const variant=product.variants.find(item=>String(item.id)===select.value);
    if(!variant)return;
    const addon=typeof window.GPOConfigs?.getSumAddOns==='function'?window.GPOConfigs.getSumAddOns():0;
    root.querySelector('[data-aura-regular]').textContent=money(variant.price+addon);
    root.querySelector('[data-aura-discounted]').textContent=money(Math.round(variant.price*.75)+addon);
    if(variant.featured_image?.src){const img=root.querySelector('.aura-offer__image');img.removeAttribute('srcset');img.src=variant.featured_image.src;}
  };
  form.addEventListener('click',event=>{if(root.dataset.state!=='ready'&&event.target.closest('button[type="submit"]')){event.preventDefault();event.stopImmediatePropagation();}},true);
  form.addEventListener('submit',event=>{if(root.dataset.state!=='ready'){event.preventDefault();event.stopImmediatePropagation();}},true);
  select.addEventListener('change',showPrice);
  document.addEventListener('gpoProductPriceUpdated',showPrice);
  let attempts=0;
  const initialize=async()=>{
    const gpo=window.GPOConfigs;
    if(typeof gpo?.loadMainScripts!=='function'||!gpo.translations){
      if(++attempts<80){window.setTimeout(initialize,250);return;}
      root.dataset.state='error';root.querySelector('[data-aura-status]').textContent=root.dataset.error;return;
    }
    try{
      gpo.product=product;gpo.form=form;
      await gpo.loadMainScripts(product,gpo.customer,form);
      if(!form.querySelector('.gpo-app input[type="file"]'))throw new Error('Personalization form unavailable');
      root.dataset.state='ready';showPrice();
    }catch(error){console.warn('Aura cart integration:',error);root.dataset.state='error';root.querySelector('[data-aura-status]').textContent=root.dataset.error;}
  };
  initialize();
  const cartItems=document.querySelector('cart-items');let refresh;
  if(cartItems)new MutationObserver(()=>{
    window.clearTimeout(refresh);
    refresh=window.setTimeout(async()=>{
      try{
        const response=await fetch(window.Shopify.routes.root+'cart.js');if(!response.ok)return;
        const cart=await response.json();
        root.hidden=!cart.items.some(item=>item.product_id===8134121095283)||cart.items.some(item=>item.product_id===product.id);
      }catch(error){}
    },400);
  }).observe(cartItems,{childList:true,subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
